<template>
  <div class="tile">
    <h6 class="title primary">{{ $t("Riepilogo Missioni") }}</h6>
    <div class="circle progress-circle__container">
      <span
        class="progress-circle__percent"
        v-bind:class="{ primary: $store.getters.isMobile }"
        >{{ missionStatistics }}%</span
      >
      <svg
        class="progress-circle"
        width="106px"
        height="106px"
        viewBox="0 0 106 106"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="ProgressBar" transform="translate(-17.000000, -17.000000)">
            <filter id="dropshadow" x="-2" y="-2" width="200" height="200">
              <feGaussianBlur stdDeviation="1" />
            </filter>
            <circle
              id="Oval"
              :stroke="$store.getters.colors.primaryOpacity"
              stroke-width="10"
              fill-rule="nonzero"
              cx="70"
              cy="70"
              r="50"
            ></circle>
            <path
              stroke-linecap="round"
              class="progress-circle__path"
              :stroke="$store.getters.colors.primary"
              :stroke-dasharray="circle"
              d="M70,120 C97.6142375,120 120,97.6142375 120,70 C120,42.3857625 97.6142375,20 70,20 C42.3857625,20 20,42.3857625 20,70 C20,97.6142375 42.3857625,120 70,120 Z"
              id="Oval-Copy"
              stroke-width="13"
              fill-rule="nonzero"
              transform="translate(70.000000, 70.000000) rotate(-125.000000) translate(-70.000000, -70.000000) "
            ></path>
          </g>
        </g>
      </svg>
    </div>
    <p class="desc primary">
      {{ $t("Missioni") }} <br />
      {{ $t("completate") }}
    </p>
    <p class="desc--count primary">
      {{
        $t("Hai ancora {missioni} missioni da completare", {
          missioni: $store.getters.getUserTasks.length
        })
      }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MissionTile",
  computed: {
    ...mapGetters(["getMissionsStatistics", "getUserTasks"]),
    circle() {
      const precentage =
        this.$store.getters.getMissionsStatistics.percentage_done / 100 || 0;
      return precentage * 100 * Math.PI + ",9999";
    },
    missionStatistics() {
      const { percentage_done } = this.$store.getters.getMissionsStatistics;
      return percentage_done ? percentage_done.toFixed(0) : 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
}

.tile {
  @media (max-width: 767px) {
    background-color: transparent;
    align-self: center;
    min-width: 150px;
  }
}

.desc {
  font-weight: bold;
  @media (min-width: 767px) {
    color: #000;
  }
}
.desc--count {
  font-size: 14px;
  @media (min-width: 767px) {
    display: none;
  }
}
</style>
